import { render, staticRenderFns } from "./TabbedModelLayout.vue?vue&type=template&id=5c915e3e&scoped=true"
import script from "./TabbedModelLayout.vue?vue&type=script&lang=js"
export * from "./TabbedModelLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c915e3e",
  null
  
)

export default component.exports